import { createColumnHelper } from '@tanstack/react-table';

import { FilterType, Restriction } from '../_openapi/portfolio-optimizer';
import { getAvailableAssetClasses, getAvailableAssetTypes } from '../utils/assetUtils';
import { AssetClassTag } from '../widgets/AssetClassTag';
import { baseCol, dateCol, textCol } from '../widgets/Table/columnHelpers/colDef';
import { TradeSideTag } from '../widgets/TradeSideTag';

const columnHelper = createColumnHelper<Restriction>();
export const restrictionListColumns = [
    columnHelper.accessor(
        'type',
        textCol({
            id: 'type',
            meta: {
                filterOptionsFn: () => ['do_not_buy', 'do_not_sell', 'last_to_sell', 'must_sell'],
                filterType: FilterType.LIST,
            },
        }),
    ),
    columnHelper.accessor('side', {
        ...baseCol({ id: 'side' }),
        cell: ({ getValue }) => <TradeSideTag side={getValue()} />,
        meta: {
            filterOptionsFn: () => ['buy', 'sell'],
            filterType: FilterType.LIST,
        },
    }),
    columnHelper.accessor(
        'source',
        textCol({
            id: 'source',
            meta: {
                filterOptionsFn: () => ['account_specific_universe', 'client', 'sri', 'wash_sale'],
                filterType: FilterType.LIST,
            },
        }),
    ),
    columnHelper.accessor('householdName', textCol({ id: 'householdName' })),
    columnHelper.accessor('portfolioName', textCol({ id: 'portfolioName' })),
    columnHelper.accessor('pId', textCol({ id: 'pId' })),
    columnHelper.accessor('aC', textCol({ id: 'aC' })),
    columnHelper.accessor('portfolioGuid', textCol({ id: 'portfolioGuid' })),
    columnHelper.accessor('sId', textCol({ id: 'sId' })),
    columnHelper.accessor('symbol', textCol({ id: 'symbol' })),
    columnHelper.accessor('description', textCol({ id: 'description' })),
    columnHelper.accessor('scId', textCol({ id: 'scId' })),
    columnHelper.accessor('assetClass', {
        ...baseCol({ id: 'assetClass' }),
        cell: ({ getValue }) => <AssetClassTag assetClass={getValue()} />,
        meta: {
            filterOptionsFn: getAvailableAssetClasses,
            filterType: FilterType.LIST,
        },
    }),
    columnHelper.accessor(
        'assetType',
        textCol({
            id: 'assetType',
            meta: {
                filterOptionsFn: getAvailableAssetTypes,
                filterType: FilterType.LIST,
            },
        }),
    ),
    columnHelper.accessor('tradeDate', dateCol({ id: 'tradeDate' })),
];
